<template>
    <div>
        <Snackbar
            v-if="showSnackbar"
            :snackbarColor="snackbarColor"
            :snackbarMessage="snackbarMessage"
            @close="closeSnackbar()"
        >
        </Snackbar>
        <div class="apps-panel-menu" v-if="showAppsPanelMenu" v-on-clickaway="away">
            <v-list>
                <template v-for="(app,index) in appsInfo">
                    <div class="tile" :key="app.id" @click="switchApp(app, app.app_id,index)">
                        <v-list-tile>
                            <v-list-tile-title>{{app.app_name}}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile class="app-type">
                            <v-list-tile-title>{{app.app_type}}</v-list-tile-title>
                            <v-icon>open_in_new</v-icon>
                        </v-list-tile>
                        <v-divider v-if="index + 1 < appsInfo.length"></v-divider>
                    </div>
                </template>
            </v-list>
        </div>
        <app-terms v-if="showTnCView" :app="appNameForTnc" :session="session"></app-terms>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapGetters, mapActions} from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
import appTerms from './appTerms.vue';
import Snackbar from '../components/snackbar'
import {hideLoadIcon,showLoadIcon} from '../assets/utils/load.js';

export default {
    name: 'AppsPanelMenuVue',
    mixins: [ clickaway ],
    props:{
        appsInfo:{
            type:Array,
            default:() => [
                {
                    app_id : -1,
                    app_name : "App Name",
                    app_type : "App Type",
                    node : "Region",
                    expiration_date: null
                },
            ]
        },
    },
    data () {
        return {
            showAppsPanelMenu : true,
            showSnackbar : false,
            snackbarColor : null,
            snackbarMessage : null,
            showTnCView: false,
            hide:null,
            appNameForTnc: null
        }
    },
    components: {
        appTerms,
        Snackbar,
    },
    methods: {
        away(){
            var self=this;
            self.showAppsPanelMenu = false;
        },
        switchApp(app, app_id,index){
            var self = this;
            let formData = new FormData();
            formData.append('json',JSON.stringify({'app_id': app_id, 'accepttnc': true}));
            showLoadIcon();
            this.$loading(true);
            Vue.http.post("/launchApp/", formData).then((res)=>{
                try{
                    let data = res.data;
                    if(typeof(res['data']) == 'string'){
                        data = JSON.parse(data);
                    }
                    if(data['accept_tnc']){
                        self.session = data['access_id'];
                        self.appNameForTnc = data['app_name'];
                        self.showTnCView = true;
                    }else if(data['app_name']){
                        window.location.href = "/apps/"+data['app_name']+"/index/?at="+ data['access_id'];
                    }else{
                        // console.log("DOnt know what to do..Something went Wrong..");
                    }
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            });
        },
        // Functions to display snackbar for success/error messages
        displaySnackbar(color,message){
            var self = this;
            self.showSnackbar = false;
            setTimeout(function(){
                self.showSnackbar = true;
            },100)
            self.snackbarColor = color;
            self.snackbarMessage = message;
        },
        closeSnackbar(){
            var self = this;
            self.showSnackbar = false;
            self.snackbarColor = null;
            self.snackbarMessage = null;
        },
        showLoadIcon,
        hideLoadIcon
    }
}
</script>